import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxesStacked, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import SupplierStockBlock from "../../Components/SupplierStock";
import PageHeader from "../../Components/Common/PageHeader";
import "./style.scss";

const STORAGE_KEY = "supplier_stock_selected_workspace";

const SupplierStockPage = () => {
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loadingWorkspaces, setLoadingWorkspaces] = useState(true);

  useEffect(() => {
    Utils.setPageTitle("Supplier Stock");
  }, []);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.workspace.ALL,
          type: "GET",
          query: { page: 1, limit: 100 },
        });
        setWorkspaces(response.data || []);

        if (selectedWorkspaceId && response.data) {
          const exists = response.data.some(
            (ws) => ws._id === selectedWorkspaceId
          );
          if (!exists) {
            setSelectedWorkspaceId("");
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      } catch (error) {
        console.log("Failed to fetch workspaces:", error.message);
      } finally {
        setLoadingWorkspaces(false);
      }
    };

    fetchWorkspaces();
  }, []);

  const handleWorkspaceChange = (e) => {
    const value = e.target.value;
    setSelectedWorkspaceId(value);
    if (value) {
      localStorage.setItem(STORAGE_KEY, value);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Supplier Stock"
          description="Quản lý nhà cung cấp và tình trạng stock sản phẩm"
          icon={faBoxesStacked}
        />

        <section className="supplier-stock-workspace-card mb-4">
          <Row className="g-3 align-items-end">
            <Col md={7} lg={8}>
              <div className="supplier-stock-workspace-copy">
                <span className="supplier-stock-kicker">Workspace Context</span>
                <h5>Chọn workspace để quản lý</h5>
                <p>
                  Suppliers và sản phẩm được quản lý theo workspace. Chọn workspace để xem và
                  cập nhật tình trạng stock.
                </p>
              </div>
            </Col>
            <Col md={5} lg={4}>
              <Form.Group>
                <Form.Label className="fw-semibold">Chọn Workspace</Form.Label>
                <Form.Select
                  value={selectedWorkspaceId}
                  onChange={handleWorkspaceChange}
                  disabled={loadingWorkspaces}
                >
                  <option value="">
                    {loadingWorkspaces ? "Đang tải workspace..." : "-- Chọn workspace --"}
                  </option>
                  {workspaces.map((ws) => (
                    <option key={ws._id} value={ws._id}>
                      {ws.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </section>

        {selectedWorkspaceId ? (
          <SupplierStockBlock workspaceId={selectedWorkspaceId} />
        ) : (
          <div className="supplier-stock-empty-state text-center">
            <div className="supplier-stock-empty-state__icon-wrap">
              <FontAwesomeIcon icon={faLayerGroup} />
            </div>
            <h6>Sẵn sàng quản lý supplier stock</h6>
            <p className="mb-0">Vui lòng chọn workspace để xem và quản lý nhà cung cấp, sản phẩm.</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default SupplierStockPage;
